import React from 'react';


function RegistryMethodologyAndStatusDefinitions() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Registry Methodology and Status Definitions</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Registry Function</h2>
            <p className="leading-relaxed">
              The AASC Public Registry is the sole authoritative source for verifying an entity's standing with the Council. It provides transparency to the market by publishing the current status of all participating operators.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Status Definitions</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-[#102A43]">declared</h3>
                <p className="text-sm text-[#64748B]">The entity has successfully completed a third-party audit or rigorous review, demonstrating evidence of conformity to all applicable Foundational Control Standards.</p>
              </div>
              <div>
                <h3 className="font-bold text-[#102A43]">Accountability Declared</h3>
                <p className="text-sm text-[#64748B]">The entity has formally attested to their alignment with AASC standards but has not undergone independent verification. This is a self-reported status.</p>
              </div>
              <div>
                <h3 className="font-bold text-[#102A43]">Suspended</h3>
                <p className="text-sm text-[#64748B]">The entity's standing is temporarily paused pending an investigation into non-compliance or failure to renew.</p>
              </div>
              <div>
                <h3 className="font-bold text-[#102A43]">Revoked</h3>
                <p className="text-sm text-[#64748B]">The entity's standing has been permanently withdrawn due to confirmed violation of standards or policy.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Status Definitions - Tier Mapping</h2>
            <div className="space-y-8">
              
              {/* Tier 1 */}
              <div>
                <h3 className="text-lg font-bold text-[#2F80ED] mb-2 border-b border-blue-200 pb-1">Tier 1: Accountability Declaration</h3>
                <p className="text-sm text-gray-600 mb-4">Requires independent verification of controls.</p>
                <div className="grid gap-3">
                  <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-green-100 text-green-800 px-2 py-1 rounded">declared</span>
                    <span className="text-sm text-[#64748B]">Active status. Full compliance verified by third-party audit.</span>
                  </div>
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-yellow-100 text-yellow-800 px-2 py-1 rounded">CONDITIONALLY declared</span>
                    <span className="text-sm text-[#64748B]">Active status with minor non-conformities pending remediation within 60 days.</span>
                  </div>
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-red-100 text-red-800 px-2 py-1 rounded">SUSPENDED</span>
                    <span className="text-sm text-[#64748B]">Inactive. Status paused due to investigation or missed renewal.</span>
                  </div>
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-gray-200 text-gray-800 px-2 py-1 rounded">REVOKED</span>
                    <span className="text-sm text-[#64748B]">Inactive. Permanently removed for violation of standards.</span>
                  </div>
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-gray-100 text-gray-500 px-2 py-1 rounded">EXPIRED</span>
                    <span className="text-sm text-[#64748B]">Inactive. declaration period ended without renewal.</span>
                  </div>
                </div>
              </div>

              {/* Accountability Declaration */}
              <div>
                <h3 className="text-lg font-bold text-[#64748B] mb-2 border-b border-gray-200 pb-1">Accountability Declaration: Alignment Declaration</h3>
                <p className="text-sm text-gray-600 mb-4">Self-attestation of standards alignment.</p>
                <div className="grid gap-3">
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-blue-100 text-blue-800 px-2 py-1 rounded">ALIGNMENT DECLARED</span>
                    <span className="text-sm text-[#64748B]">Active status. Entity has formally declared adherence to standards.</span>
                  </div>
                   <div className="flex items-baseline gap-2">
                    <span className="font-mono text-xs font-bold bg-gray-100 text-gray-500 px-2 py-1 rounded">ALIGNMENT EXPIRED</span>
                    <span className="text-sm text-[#64748B]">Inactive. Declaration period ended (annual renewal required).</span>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Data Integrity</h2>
            <p className="leading-relaxed">
              The Registry is updated in real-time upon changes in status. The Council maintains archival records of past status for audit trails and historical verification.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default RegistryMethodologyAndStatusDefinitions;